<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Reports</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="search">
      <div class="row align-items-center">
        <div class="col-md-1">Company</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="company">
            <option value="">-- Please Select --</option>
            <option
              v-for="(item, i) in companies"
              :key="i"
              :value="item.CompanyName"
            >
              {{ item.CompanyName }}
            </option>
          </select>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-1" style="max-width: 80px">Year</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="year">
            <option value="">-- Please Select --</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
      <div class="row align-items-center mt-2">
        <div class="col-md-1">Effective Date</div>
        <!-- effective date -->
        <div class="col-md-5">
          <div class="row align-items-center">
            <div class="col-md-2 pl-md-0" style="max-width: fit-content">
              <input
                type="date"
                class="form-control"
                v-model="effectiveDateFrom"
              />
            </div>
            <div class="col-md-1 px-md-0" style="max-width: fit-content">
              To
            </div>
            <div class="col-md-2" style="max-width: fit-content">
              <input
                type="date"
                class="form-control"
                :min="effectiveDateFrom"
                v-model="effectiveDateTo"
              />
            </div>
          </div>
        </div>
        <!-- /effective date -->

        <div class="col-md-1" style="max-width: 80px">Status</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="status">
            <option value="">-- Please Select --</option>
            <option value="Active">Active</option>
            <option value="Resigned">Resigned</option>
          </select>
        </div>
        <div class="col-md-1">
          <button type="submit" class="btn btn-primary">Search</button>
        </div>
      </div>

      <div v-if="effectiveDateFrom || effectiveDateTo" class="row align-items-center mt-2">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <div class="row align-items-center">
            <button type="button" class="btn btn-secondary" v-on:click="resetEffectiveDate()">Reset Effective Date</button>
          </div>
        </div>
      </div>
    </form>
    <!-- Form -->

    <!-- Pagination -->
    <div class="row mt-4 align-items-center" v-if="records && records.length">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-right">
        <form
          :action="backendUrl + '/BenefitExcelReport/ExportExcel'"
          method="POST"
        >
          <input type="hidden" name="Company" :value="companyForExcel" />
          <input type="hidden" name="Year" :value="yearForExcel" />
          <input
            type="hidden"
            name="EffectiveDateFrom"
            :value="effectiveDateFromForExcel"
          />
          <input
            type="hidden"
            name="EffectiveDateTo"
            :value="effectiveDateToForExcel"
          />
          <input type="hidden" name="Status" :value="statusForExcel" />
          <button type="submit" class="btn btn-sm btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="records && records.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>

    <!-- Result -->
    <div class="row mt-2" v-if="records && records.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <th>Org Level 1</th>
                <th>Level 2</th>
                <th>Level 3</th>
                <th>Date of Hire</th>
                <th>Position Title</th>
                <th>Job Grade</th>
                <th>Year</th>
                <th>Effective Date</th>
                <th>Benefit Option Plan</th>
                <th v-for="item in benefitItems" :key="item.BenefitItem">
                  {{ item.BenefitItem }}
                </th>
                <th>Acknowledged By</th>
                <th>Acknowledged Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in records" :key="i">
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.EmployeeID }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.EmployeeName }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.OrgLevel1 }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.Level2 }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.Level3 }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.DateHireDisplay }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.PositionTitle }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.JobGrade }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.Year }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.EffectiveDateDisplay }}
                </td>
                <td>{{ item.BenefitOptionPlan }}</td>
                <td v-for="(benefitItem, i) in item.BenefitItems" :key="i">
                  {{
                    item.Type == "Prorate" && !benefitItem.Value
                      ? "N.A"
                      : benefitItem.Value
                  }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{ item.Type == "Prorate" ? "" : item.AcknowledgedBy }}
                </td>
                <td :class="item.Type == 'Prorate' ? 'prorate' : ''">
                  {{
                    item.Type == "Prorate" ? "" : item.AcknowledgmentDateDisplay
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Result -->

    <!-- Pagination -->
    <div class="row" v-if="records && records.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!-- /Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      companies: [],
      years: [],
      records: [],
      //search form
      company: "",
      year: "",
      effectiveDateFrom: "",
      effectiveDateTo: "",
      status: "",
      //for excel
      companyForExcel: "",
      yearForExcel: "",
      effectiveDateFromForExcel: "",
      effectiveDateToForExcel: "",
      noRecordText: config.NO_RECORD_TEXT,
      statusForExcel: "",
      //pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 5,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    backendUrl() {
      return this.$backendUrl;
    },
    benefitItems() {
      if (this.records && this.records.length)
        return this.records[0].BenefitItems;
      else return [];
    },
  },

  watch: {
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.search();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    search() {
      //store variable for export excel
      this.companyForExcel = this.company;
      this.yearForExcel = this.year;
      this.effectiveDateFromForExcel = this.effectiveDateFrom;
      this.effectiveDateToForExcel = this.effectiveDateTo;
      this.statusForExcel = this.status;
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
        Company: this.company,
        Year: this.year,
        EffectiveDateFrom: this.effectiveDateFrom,
        EffectiveDateTo: this.effectiveDateTo,
        Status: this.status,
      };
      this.$store.state.isLoading = true;
      API.getBenefitReport(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    resetEffectiveDate() {
      this.effectiveDateFrom = "";
      this.effectiveDateTo = "";
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.search();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.search();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.search();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.search();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.search();
    },
  },

  created() {
    if (this.role != "admin") {
      this.$router.replace({ name: "home" });
      return;
    }
    this.getCompanies();
    this.getYears();
  },
};
</script>

<style scoped>
input[type="date"] {
  width: 150px;
}

.prorate {
  background-color: #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/Benefit/Report.vue